import React, {useCallback, useEffect, useState} from 'react';

import {useDispatch, useSelector} from 'react-redux';
import {alertActions, documentActions} from '../../../../store/actions';
import {
  Paper,
} from '@mui/material';

import {AccordionCard, DocumentDetailsWithLoadMore, FileViewer} from '../../components';
import Card from '../../../../components/Card/CardBody';
import CardBody from '../../../../components/Card/CardBody';
import PageHeader from '../../../../components/PageHeader/PageHeader';
import Grid from '@mui/material/Grid';
import LoadingSpinner from "../../../../components/Spinner/loading.spinner";
import {documentService, vodService} from "../../../../store/services";
import {DOCUMENT_STATUS} from "../../../../constants/DOCUMENT_STATUS";
import {DOCUMENT_VIEWER_MODES} from "../../../../constants/DOCUMENT_VIEWER_MODES";
import FilterListIcon from "@mui/icons-material/FilterList";
import useStyles from './styles';
import TabList from "../../../../components/Tab/TabList";
import FileListTabMode from "./FileListTabMode";
import {SharedUsersTable} from "../../../SharedUser/SharedUserList/components";
import moment from "moment";

const FileListWindow = (props) => {
  const {
    title = 'Multimedia', subtitle = 'Available Multimedia',
    initialSection = 'All Sections', includeSectionFilter = false,
    initialCompany = 'All Companies', includeCompanyFilter = false,
    initialClassification = 'All Media Types', includeClassificationFilter = false,
    initialCategory = 'All Categories', includeCategoryFilter = false,
    initialStatus = DOCUMENT_STATUS.APPROVED, includeStatusFilter = false,
    initialBeginDate, includeBeginDate = false,
    initialEndDate, includeEndDate = false,
    initialFilename = '', includeFilename = false,
    initialAttribute = '', includeAttribute = false,
    // initialNbrOfDocuments = 5,
    viewer = DOCUMENT_VIEWER_MODES.LIST,
    sharedUser = false,
    sharedUserGuid = '',
    userGuid = '',
    sharedUserRole = false,
    documentsByMember = false,
    by_vdr = false,
    getDocumentFromDocumentServiceMethod = (id) => documentService.getDocumentById(id),
    searchDocumentFromDocumentServiceMethod = (searchFields) => documentActions.searchDocuments(searchFields)
  } = props;

  const classes = useStyles();
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [currentPage, setCurrentPage] = useState(0);

  let {filteredDocs, documentsUpdated} = useSelector(state => {
    return {filteredDocs: (state.documents ? state.documents.items : []), documentsUpdated: true}
  });

  const {
    documents,
    categories,
    classifications,
    sections,
    companies
  } = filteredDocs ? filteredDocs : {};

  const {
    id,
    role,
    company,
    companyId,
    name
  } = useSelector(state => state.authentication.user);

  const [totalDocuments, setTotalDocuments] = useState(0);
  const [classificationSelect, setClassificationSelect] = useState(initialClassification);
  const [categorySelect, setCategorySelect] = useState(initialCategory);
  const [sectionSelect, setSectionSelect] = useState(initialSection);
  const [companySelect, setCompanySelect] = useState(initialCompany);
  const [statusSelect, setStatusSelect] = useState(initialStatus);
  const [beginDate, setBeginDate] = useState(initialBeginDate);
  const [endDate, setEndDate] = useState(initialEndDate);
  const [filename, setFilename] = useState(initialFilename);
  const [attribute, setAttribute] = useState(initialAttribute);
  // const [nbrOfItemsToReturn, setNbrOfItemsToReturn] = useState(rowsPerPage);


  const [statusList] = useState([
    DOCUMENT_STATUS.REJECTED,
    DOCUMENT_STATUS.REMOVED,
    DOCUMENT_STATUS.HOLD,
    DOCUMENT_STATUS.WAITING
  ]);

  const [initialLoad, setInitialLoad] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [expanded, setExpanded] = useState(false);

  const [searchFields, setSearchFields] = useState({
    company_guid: companyId,
    company_selection: companySelect,
    user_guid: sharedUser ? userGuid : id,
    section: sectionSelect,
    classification: classificationSelect,
    category: categorySelect,
    status: statusSelect,
    start_date: beginDate,
    end_date: endDate,
    file_name: filename,
    shared_user_guid: sharedUserRole ? id : sharedUserGuid,
    role: role,
    by_vdr: by_vdr,
    documentsByMember: documentsByMember,
    attribute: attribute,
    totalItemsToReturn: rowsPerPage
  });

  let documentFields = {
    'document_guid': '',
    'user_guid': id,
    'company_guid': companyId,
    'notes': '',
  }

  const handleApproved = (documentId, tabId, displayName, section, owner_guid, status) => {
    fillDocumentFields(documentId, tabId, {
      'notes': null,
      'private': 0,
    }, displayName, section, owner_guid, status);
    approveDocument(documentFields).then(dtls => {
      searchDocWithFilters(document.length);
    });
    tabListRef.current.closeTab(tabId);
  };

  const handleBeginDateChange = date => {
    setBeginDate(moment(date));
  };

  const handleCategorySelect = event => {
    setCategorySelect(event.target.value);
  };

  const handleClassificationSelect = event => {
    setClassificationSelect(event.target.value);
  };

  const handleClickedView = rowData => {
    loadTab(rowData, getDocumentForLoadingTab(rowData), rowData.status);
  }

  const handleClickedSharedUserView = rowData => {
    loadSharedUserTab(rowData, rowData.status);
  }

  const handleClickToggleShareable= (displayName, guid, shareable) => {
    documentService.toggleShareable(guid, shareable).then(document => {
      searchDocWithFilters(document.length);
    });
  }

  const handleCompanySelect = event => {
    setCompanySelect(event.target.value);
  };

  const handleEndDateChange = date => {
    setEndDate(moment(date));
  };

  const handleFilenameChange = event => {
    setFilename(event.target.value);
  };

  const handleAttributeChange = event => {
    setAttribute(event.target.value);
  };

  const handleFilterClick = event => {
    setTotalDocuments(0);

    searchDocWithFilters(0);
    setFilename('');
    setAttribute('');
  };

  const handleHoldForQuestions = (documentId, tabId, values, displayName, section, ownerGuid) => {
    fillDocumentFields(documentId, tabId, values, displayName, section, ownerGuid, DOCUMENT_STATUS.HOLD);

    holdDocument(documentFields).then(dtls => {
      searchDocWithFilters(document.length);
    });
    tabListRef.current.closeTab(tabId);
  };

  const handleRejected = (documentId, tabId, values, displayName, section, ownerGuid) => {
    fillDocumentFields(documentId, tabId, values, displayName, section, ownerGuid, DOCUMENT_STATUS.REJECTED);

    rejectDocument(documentFields).then(dtls => {
      searchDocWithFilters(document.length);
    });
    tabListRef.current.closeTab(tabId);
  };

  const handleRemove = (documentId, tabId, values, displayName, section, ownerGuid) => {
    fillDocumentFields(documentId, tabId, values, displayName, section, ownerGuid, DOCUMENT_STATUS.REMOVED);

    removeDocument(documentFields).then(dtls => {
      searchDocWithFilters(document.length);
    });

    tabListRef.current.closeTab(tabId);
  };

  const handleRemoveShare = (documentId, tabId) => {
    documentFields.document_guid = documentId;
    documentFields.user_guid = id;
    documentFields.shared_user_guid = sharedUserGuid;
    removeShareToDocument(documentFields).then(dtls => {
      searchDocWithFilters(document.length);
    });
    tabListRef.current.closeTab(tabId);
  };

  const handleSectionSelect = event => {
    setSectionSelect(event.target.value);
  };

  const handleShare = (documentId, tabId) => {
    documentFields.document_guid = documentId;
    documentFields.user_guid = id;
    documentFields.shared_user_guid = sharedUserGuid;
    addShareToDocument(documentFields).then(dtls => {
      searchDocWithFilters(document.length);
    });

    tabListRef.current.closeTab(tabId);
  };

  const handleStatusSelect = event => {
    setStatusSelect(event.target.value);
  };

  async function approveDocument(documentFields) {
    return await documentService.approveDocumentUpload(documentFields)
      .then(response => {
          statusAlertMessage(documentFields.status);
          return response.data
        }
      )
  }
  function fillDocumentFields(documentId, tabId, values, displayName, section, owner_guid, status) {
    documentFields.document_guid = documentId;
    documentFields.owner_guid = owner_guid;
    documentFields.section = section;
    documentFields.displayName = displayName;
    documentFields.user_guid = id;
    documentFields.company_guid = companyId;
    documentFields.notes = values.notes;
    documentFields.private = values.private;
    documentFields.status = status;
  }

  async function getDocument(displayName, documentGuid) {
    return await getDocumentFromDocumentServiceMethod(documentGuid)
      .then(document => {
        //Not including document.type.split(";")[0] will cause issues in Safari, where the type returned would be "text/plain;charset=utf-8" instead of "text/plain"
        if (document.type.split(";")[0] !== "text/plain")
          return document;
        else
          return getDocumentFromVodServiceMethod(document);
      });
  }

  async function getDocumentFromVodServiceMethod(document) {
    let url = await document.text()
    return await vodService.getVoDFile(url, sharedUser);
  }

  async function holdDocument(documentFields) {
    return await documentService.holdDocumentUpload(documentFields)
      .then(response => {
          statusAlertMessage(documentFields.status);
          return response.data
        }
      )
  }

  function loadNewTab(tabData, document, status) {
    tabListRef.current.addTab(
      (tabId)=>(tabData.display_name) ? (tabData.display_name) : ('PANEL ' + tabId),
      (tabId) => FileListTabMode.DOCUMENT,
      (tabId)=>(<FileViewer
        classes={classes}
        approval={(viewer === 'staged').toString()}
        file={document}
        tabData={tabData}
        guid={tabData.guid}
        company_guid={tabData.company_guid}
        displayName={tabData.display_name}
        notesCount={tabData.notesCount}
        metaData={tabData.metaData}
        onHandleApproved={handleApproved}
        onHandleHoldForQuestions={handleHoldForQuestions}
        onToggleShareable={handleClickToggleShareable}
        onHandleRejected={handleRejected}
        onHandleRemove={handleRemove}
        onHandleShare={handleShare}
        onHandleRemoveShare={handleRemoveShare}
        shared={tabData.shared}
        status={status}
        shareable={tabData.shareable}
        tabId={tabId}
        view={viewer}
      />)
    );
  }

  function loadNewSharedUserTab(tabData, status) {
    tabListRef.current.addTab(
      (tabId)=>(tabData.display_name) ? (`VDRs for ${tabData.display_name}`) : ('PANEL ' + tabId),
      (tabId) => FileListTabMode.DOCUMENT,
      (tabId) => (<SharedUsersTable
        subtitle={"Document Shared With "}
        memberGuid={id}
        companyId={companyId}
        memberName={name}
        documentId={tabData.guid}
        showMember={true}
      />)
    );
  }

  function loadTab(tabData, documentData, status) {
    let labelFound = getTabsByDisplayNameAndTabMode(tabData.display_name, FileListTabMode.DOCUMENT);
    if (labelFound.length === 0) {
      loadNewTab(tabData, documentData, status);
    }
    else {
      tabListRef.current.changeTab(labelFound[0].id);
    }
  }

  function loadSharedUserTab(tabData, status){
    let labelFound = getTabsByDisplayNameAndTabMode(tabData.display_name, FileListTabMode.SHARED_USERS_OF_DOCUMENT);
    if (labelFound.length === 0)
      loadNewSharedUserTab(tabData, status);
    else
      tabListRef.current.changeTab(labelFound[0].id);
  }

  function getTabsByDisplayNameAndTabMode(displayName, tabMode){
    return tabListRef.current.tabList.filter(tabValue => displayName === tabValue.label && tabValue.mode === tabMode ? 1 : 0);
  }

  function getDocumentForLoadingTab(documentInfo){
    let index = files.findIndex(x => x.id === documentInfo.guid);
    return index !== -1 ?
      files[index] :
      getDocument(documentInfo.display_name, documentInfo.guid).then(document => {
        setFiles(prevState => [...prevState, {id: documentInfo.guid, data: document}]);
        return document;
      });
  }

  async function rejectDocument(documentFields) {
    return await documentService.rejectDocumentUpload(documentFields)
      .then(response => {
          statusAlertMessage(documentFields.status);
          return response.data
        }
      )
  }

  async function removeDocument(documentFields) {
    return await documentService.removeDocumentUpload(documentFields)
      .then(response => {
          statusAlertMessage(documentFields.status);
          return response.data
        }
      )
  }

  async function searchDocWithFilters(docLength=0)  {
    setLoading(true);

    setTotalDocuments(docLength + rowsPerPage);

    // needed this to capture new filters without lag when using set
    const currentSearchFields = {
      ...searchFields,
      company_selection: companySelect,
      section: sectionSelect,
      classification: classificationSelect,
      category: categorySelect,
      status: statusSelect,
      start_date: beginDate,
      end_date: endDate,
      file_name: filename,
      attribute: attribute,
      by_vdr:by_vdr,
      documentsByMember: documentsByMember,
      totalItemsToReturn: docLength + rowsPerPage
    }

    // Need to pass new filters to DocumentDetails.....
    setSearchFields(currentSearchFields);

    const returnedDocs = await dispatch(searchDocumentFromDocumentServiceMethod(currentSearchFields))
      .then(
        documents => {
          setLoading(false);
          return documents;
        }, error =>{
          setLoading(false);
          throw error;
        }
    );

    if (!returnedDocs || !returnedDocs.data)
      return [];

    return returnedDocs.data.documents;
  }

  const searchDocWithFiltersCallback = useCallback(searchDocWithFilters,
    [searchFields, companySelect, sectionSelect, classificationSelect, categorySelect, statusSelect, beginDate, endDate, filename, attribute, by_vdr, documentsByMember, dispatch, searchDocumentFromDocumentServiceMethod, rowsPerPage]);

  function statusAlertMessage(status) {
    dispatch(alertActions.success("Status of document was changed to " + status));
  }

  async function removeShareToDocument(documentFields) {
    return await documentService.removeShareDocument(documentFields)
      .then(response => {
          return response.data
        }
      )
  }

  async function addShareToDocument(documentFields) {
    return await documentService.addShareDocument(documentFields)
      .then(response => {
          return response.data
        }
      )
  }

  const filterCard = (!filteredDocs || !documents || initialLoad) ?
    (<LoadingSpinner/>) :
    (<Card
      plain
      style={{margin: 0}}
    >
      <CardBody style={{padding: 0}}>
        <Grid
          alignItems={'center'}
          container
          justifyContent={'center'}
          style={{padding: 0, margin: 0}}
        >
          <AccordionCard
            classes={classes}
            summaryText="Multimedia Filters"
            company={company}
            role={role}
            expanded={expanded}
            setExpanded={setExpanded}

            initialSections={sections}
            initialCompanies={companies}
            initialCategories={categories}
            initialClassifications={classifications}
            initialStatus={statusList}

            sectionSelect={sectionSelect}
            companySelect={companySelect}
            categorySelect={categorySelect}
            classificationSelect={classificationSelect}
            statusSelect={statusSelect}

            beginDate={beginDate}
            filename={filename}
            endDate={endDate}
            attribute={attribute}

            onHandleSectionSelect={includeSectionFilter ? handleSectionSelect : undefined}
            onHandleCompanySelect={includeCompanyFilter ? handleCompanySelect : undefined}
            onHandleCategorySelect={includeCategoryFilter ? handleCategorySelect : undefined}
            onHandleClassificationSelect={includeClassificationFilter ? handleClassificationSelect : undefined}
            onHandleStatusSelect={includeStatusFilter ? handleStatusSelect : undefined}
            onHandleBeginDateSelect={includeBeginDate ? handleBeginDateChange : undefined}
            onHandleEndDateSelect={includeEndDate ? handleEndDateChange : undefined}
            onFilenameChange={includeFilename ? handleFilenameChange : undefined}
            onAttributeChange={includeAttribute ? handleAttributeChange : undefined}

            buttonText="Filter"
            buttonIcon={FilterListIcon}
            onButtonClick={handleFilterClick}
          />
          {isLoading ? (<LoadingSpinner/>) : (
            <DocumentDetailsWithLoadMore
              classes={classes}
              companySelect={companySelect}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              page={page}
              setPage={setPage}
              documentsUpdated={documentsUpdated}
              setDocumentsUpdated={(newValue) => {
                documentsUpdated = newValue
              }}
              totalDocuments={totalDocuments}
              setTotalDocuments={setTotalDocuments}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              documents={documents}
              onView={handleClickedView}
              onSharedUserView={handleClickedSharedUserView}
              searchDocWithFilters={searchDocWithFilters}
              isSharedUser={sharedUser}
              role={role}
              viewer={viewer}
              searchFields={searchFields}
            />
          )}
        </Grid>
      </CardBody>
    </Card>);

  const tabListRef = React.useRef({})

  const tabList = (<TabList
    label="Multimedia Tabs"
    indicatorColor="secondary"
    scrollButtons="auto"
    textColor="primary"
    variant="scrollable"
    defaultTabName="Multimedia"
    defaultTabPanel={filterCard}
    ref={tabListRef}
    currentPage={currentPage}
  />)

  useEffect(() => {
    if (initialLoad && companySelect) {
      searchDocWithFiltersCallback();
      setInitialLoad(false);
    }
  }, [dispatch, companySelect, filteredDocs, initialLoad, searchDocWithFiltersCallback]);

  return (
    <div className={classes.root}>
      <PageHeader title={title} subTitle={subtitle}/>
      <Card className={classes.content}>
        <CardBody style={{backgroundColor: '#FFF', padding: 0}}>
          <Paper
            elevation={1}
            style={{padding: 10, margin: 0}}
          >
            {tabList}
          </Paper>
        </CardBody>
      </Card>
    </div>
  )
}

export default FileListWindow;
